/* GNCC Phlur-Style Jumbo Menu — JS */
(function(){
  var FOCUSSABLE='a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])';
  var listenersBound = false;
  var drawerEl = null;

  function getDrawer(){
    return document.querySelector('.gncc-jumbo-drawer');
  }

  function visibleItems(drawer){
    return Array.from(drawer.querySelectorAll(FOCUSSABLE)).filter(function(el){
      return el.offsetParent!==null;
    });
  }

  function openDrawer(opener){
    var backdrop = document.querySelector('.gncc-jumbo-backdrop');
    var drawer = getDrawer();
    if(!backdrop || !drawer) return;
    backdrop.classList.add('gncc-show');
    drawer.classList.add('gncc-open');
    drawer.removeAttribute('data-gncc-root-hidden');
    drawer.removeAttribute('inert');
    document.body.classList.add('gncc-jumbo-open');
    document.body.style.overflow='hidden';
    showScreen('root', drawer);
    if(opener){
      drawer._returnFocus = opener;
      opener.setAttribute('aria-expanded','true');
    }
    // move focus into the drawer
    var first = visibleItems(drawer)[0];
    if(first) first.focus();
  }

  function closeDrawer(){
    var backdrop = document.querySelector('.gncc-jumbo-backdrop');
    var drawer = getDrawer();
    if(!backdrop || !drawer) return;
    backdrop.classList.remove('gncc-show');
    drawer.classList.remove('gncc-open');
    drawer.setAttribute('data-gncc-root-hidden','');
    drawer.setAttribute('inert','');
    document.body.classList.remove('gncc-jumbo-open');
    document.body.style.overflow='';
    var rf = drawer._returnFocus;
    if(rf){
      rf.setAttribute('aria-expanded','false');
      if(rf.focus) rf.focus();
    }
    setTimeout(function(){ showScreen('root', drawer); }, 350);
  }

  function showScreen(name, drawer){
    var target = null;
    drawer.querySelectorAll('.gncc-jumbo-screen').forEach(function(s){
      var active = s.dataset.gnccScreen===name;
      s.classList.toggle('gncc-active', active);
      if(active) target = s;
    });
    var titleEl = drawer.querySelector('[data-gncc-screen-title]');
    if(target && titleEl){
      var h = target.querySelector('.gncc-jumbo-heading');
      titleEl.textContent = h ? h.textContent : 'Shop';
    }
    var inner = drawer.querySelector('.gncc-jumbo-inner');
    if(inner) inner.scrollTop = 0;
    // move focus to the first interactive element in the new screen
    var first = target ? visibleItems(target)[0] : null;
    if(first) first.focus();
  }

  function init(root){
    // bind the drawer triggers (desktop "Shop" button)
    root.querySelectorAll('[data-gncc-jumbo]').forEach(function(trigger){
      if(trigger.dataset.gnccBound) return;
      trigger.dataset.gnccBound='1';
      trigger.setAttribute('aria-expanded','false');
      trigger.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        openDrawer(trigger);
      });
    });

    // close buttons, goto buttons, back buttons
    root.querySelectorAll('[data-gncc-close]').forEach(function(b){
      if(b.dataset.gnccBound) return;
      b.dataset.gnccBound='1';
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); closeDrawer(); });
    });
    root.querySelectorAll('[data-gncc-goto]').forEach(function(b){
      if(b.dataset.gnccBound) return;
      b.dataset.gnccBound='1';
      b.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var drawer = getDrawer();
        if(drawer) showScreen(b.dataset.gnccGoto, drawer);
      });
    });
    root.querySelectorAll('[data-gncc-back]').forEach(function(b){
      if(b.dataset.gnccBound) return;
      b.dataset.gnccBound='1';
      b.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var drawer = getDrawer();
        if(drawer) showScreen(b.getAttribute('data-gncc-back') || 'root', drawer);
      });
    });
  }

  // document-level listeners — bound exactly once
  function bindDocumentListeners(){
    if(listenersBound) return;
    listenersBound = true;

    document.addEventListener('focusin', function(e){
      var drawer = getDrawer();
      if(!drawer || !drawer.classList.contains('gncc-open')) return;
      if(drawer.contains(e.target)) return;
      // focus left the drawer while open — move it back in (contain focus)
      var first = visibleItems(drawer)[0];
      if(first) first.focus();
    });

    document.addEventListener('keydown', function(e){
      var drawer = getDrawer();
      if(!drawer || !drawer.classList.contains('gncc-open')) return;
      if(e.key==='Escape'){ e.preventDefault(); closeDrawer(); return; }
      if(e.key==='Tab'){
        // focus loop within the drawer
        var items = visibleItems(drawer);
        if(!items.length) return;
        var first = items[0], last = items[items.length-1];
        if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
        else if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      }
    });
  }

  // mobile: intercept hamburger + Foxify drawer "Shop" items so they open the jumbo drawer
  function wireMobileDrawer(){
    var drawer = document.querySelector('header-drawer');
    if(!drawer) return;
    var shopItem = null;
    drawer.querySelectorAll('summary, [data-menu-button], button, a').forEach(function(el){
      if(shopItem) return;
      if(el.dataset.gnccDrawerBound) return;
      var t = el.textContent.trim().toLowerCase();
      if(t !== 'shop' && t !== 'shop ▸') return;
      shopItem = el;
    });
    if(shopItem){
      shopItem.dataset.gnccDrawerBound = '1';
      shopItem.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        openDrawer(null);
      }, true);
    }
  }

  function wireMobileHamburger(){
    var h = document.querySelector('#MenuDrawer-HamburgerIcon, header-drawer .header__icon');
    if(!h || h.dataset.gnccDrawerBound) return;
    h.dataset.gnccDrawerBound = '1';
    h.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      openDrawer(h);
    }, true);
  }

  function wireMobileDrawerObserver(){
    var drawer = document.querySelector('header-drawer');
    wireMobileHamburger();
    wireMobileDrawer();
    if(!drawer) return;
    var obs = new MutationObserver(function(){
      wireMobileHamburger();
      wireMobileDrawer();
    });
    obs.observe(drawer, {childList:true, subtree:true, attributes:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', function(){
      init(document);
      bindDocumentListeners();
      wireMobileDrawerObserver();
    });
  } else {
    init(document);
    bindDocumentListeners();
    wireMobileDrawerObserver();
  }

  // re-init — called by the section after it injects the trigger
  window.gnccJumboInit = function(){
    init(document);
    bindDocumentListeners();
    wireMobileDrawerObserver();
  };
  // expose open for programmatic use
  window.gnccJumboOpen = function(opener){ openDrawer(opener||null); };
  // auto-poll until the trigger is injected by the section's inline script
  function autoBind(){
    var t = document.querySelector('[data-gncc-jumbo]');
    if(t && !t.dataset.gnccBound){ init(document); }
    if(!t || t.dataset.gnccBound){ return; }
    setTimeout(autoBind, 50);
  }
  autoBind();
})();
